import React from 'react';
import styles from './circleCompleteLoader.module.css';
const CircleCompleteLoader = () => {
  return <div className={styles.loader}></div>;
};

export default CircleCompleteLoader;
